module.exports = __webpack_public_path__ + "static/blog-12-52ec2f603289c8a95c96d4a75481b038.png";